//-------------MONITORING_COPY--------------
import React from "react";
import {Pane, PaneProps} from "evergreen-ui";
import {useSelectedDatasourceTypesIdsMonitoring} from "../../Hooks/useSelectedDatasourceTypesIdsMonitoring";
import {MemoDatasourceTypeSelectMonitoring} from "../../Selectors/DatasourceTypesSelectMonitoring";
import {DatasourcesFilterByStatusesMonitoring} from "./FilterByStatusesMonitoring";

export function DatasourcesFilterMonitoring(props: PaneProps) {
  const { datasourceTypesIds, onChangeDatasourceTypesIds } = useSelectedDatasourceTypesIdsMonitoring();
  return (
    <Pane display="flex" gap=".2rem" {...props}>
      <MemoDatasourceTypeSelectMonitoring selected={datasourceTypesIds} onSelect={onChangeDatasourceTypesIds} />
      <DatasourcesFilterByStatusesMonitoring />
    </Pane>
  );
}
export default DatasourcesFilterMonitoring;